import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import configMenu from '@/views/custom-layout/components/configMenu.vue';
import { getPictureByKey } from '@/views/custom-layout/api';
import { isEmpty } from '@/utils';
export default {
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary,
    configMenu: configMenu
  },
  name: 'magic_nav_auto_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    menuList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    childrenMenuList: Array,
    customerModuleList: Array,
    eBookCategoryList: Array,
    aBookCategoryList: Array,
    customerPackageList: Array,
    systemMenus: Object,
    info: Object,
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      showPictureLibrary: false,
      pictureInfo: {},
      pictureList: [],
      updateIndex: 0,
      pictureIndex: 1,
      depot: {},
      updateProp: '',
      subhead: ''
    };
  },
  methods: {
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this = this;
      getPictureByKey({
        key: this.value.key,
        key_type: this.value.config.magic_type
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this.pictureInfo = picture;
        _this.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config.value[this.updateIndex][this.updateProp] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(index, pictureIndex, prop) {
      // updateIndex: 在onChangePic中对应将组件内第几张图片替换为图库中图片
      // pictureList: 图库中图片列表
      this.updateIndex = index;
      this.updateProp = prop;
      this.pictureIndex = pictureIndex;
      this.pictureList = this.pictureInfo[pictureIndex];
      this.subhead = prop === 'small_imageurl' ? '小图' : '长图';
      this.showPictureLibrary = true;
    },
    onDelete: function onDelete(item, prop) {
      if (!item[prop]) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        item[prop] = '';
      });
    },
    onUpload: function onUpload(index, type) {
      this.$refs["uploadBanner".concat(type)][index].uploadBanner();
    },
    emitUploadFile: function emitUploadFile(res, item, prop) {
      item[prop] = "".concat(this.$ossurl).concat(res);
    }
  },
  created: function created() {
    if (isEmpty(this.value.config.value)) {
      this.$set(this.value, 'config', JSON.parse(JSON.stringify(this.value.config_default_value)));
    }
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index //兼容新老组件 默认预置2
    }));
    this.getPicture();
  }
};